module.exports = __webpack_public_path__ + "img/floor5Bg.e36b205d.png";